import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { routes } from "../constants";
import createStore from "../store/store";
import { Provider } from "../store/store-context";
import { useIoContext } from "./IoContext";
export function StateStoreProvider(props) {
  const {
    children,
    mgmtHost,
    apiGatewayHost,
    apiHost,
    authDomain,
    useAuthorizationHeader = false,
    initialState,
    sessionTimeoutMS
  } = props;
  const history = useHistory();
  const {
    getIntercom,
    getNow,
    slackClient
  } = useIoContext();
  const storeCreator = useMemo(() => () => createStore(initialState || {}, {
    mgmtHost,
    apiGatewayHost,
    apiHost,
    authDomain,
    useAuthorizationHeader,
    sessionTimeoutMS
  }, () => history.push(routes.logout), getNow, getIntercom, slackClient), // eslint-disable-next-line react-hooks-static-deps/exhaustive-deps
  []);
  return /*#__PURE__*/React.createElement(Provider, {
    createStore: storeCreator
  }, children);
}